import { i18n } from '@/plugins/i18n'
import { openBankingRequestStatusVariant, openBankingRequestsStatusStr,providerTypeStr } from '@/constants/openBanking'
import DescriptionColumn from "../../requests-description-column";
import {sourceTypeStr} from "@/constants/openbankingSourceType";

const descriptionTemplate = (row, index, datatable) => {
    let template = new DescriptionColumn({
        props: {
            row,
            index,
            datatable,
        },
        i18n,
    })

    template.row = row
    template.index = index
    template.datatable = datatable

    return template.$mount().$el
}
export default [
    {
        field: 'id',
        title: '#',
        sortable: true,
        width: 70,
        type: 'number',
        textAlign: 'center',
    },
    {
        field: 'application_id',
        title: i18n.t('application.title'),
        sortable: false,
        textAlign: 'center',
        template: (row) => {
            return '<a href="/applications/' + row.application_id + '/details">'+row.application_title+'</a>'
        },
    },
    {
        field: 'service_type',
        title: i18n.t('open_banking.service_title'),
        template: (row) => {
            let service_type  = i18n.t('application.services.' + row.service_type)

            return '<div>'+ service_type+'</div>'
        },
        sortable: false,
        width: 80,
        textAlign: 'center',
    },
    {
        field: 'source',
        title: i18n.t('open_banking.source'),
        sortable: false,
        width: 80,
        textAlign: 'center',
    },
    {
        field: 'status',
        sortable: true,
        textAlign: 'center',
        title: i18n.t('label.status'),
        template: (row) => {
            let status  = openBankingRequestsStatusStr.get(row.status)
            let variant = 'badge-'+openBankingRequestStatusVariant(row.status)

            return '<div class="badge '+variant+' text-white">'+ status+'</div>'
        },
        width: 80
    },
    {
        field: 'created_at',
        title: i18n.t('label.created_at'),
        sortable: false,
        width: 80,
        textAlign: 'center',
    },
    {
        field: 'description',
        width: 80,
        title: i18n.t('label.description'),
        template: (row, index, datatable) => {
            return descriptionTemplate(row, index, datatable)
        },
        sortable: false,
        textAlign: 'center',
    },
]